/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Credit_Exhaustion_TailoredInputs */

const en_credit_exhaustion_tailored = /** @type {(inputs: Credit_Exhaustion_TailoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tailored ${i?.count} resumes`)
};

const de_credit_exhaustion_tailored = /** @type {(inputs: Credit_Exhaustion_TailoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Lebensläufe angepasst`)
};

const fr_credit_exhaustion_tailored = /** @type {(inputs: Credit_Exhaustion_TailoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} CV adaptés`)
};

const es_credit_exhaustion_tailored = /** @type {(inputs: Credit_Exhaustion_TailoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} currículos adaptados`)
};

const it_credit_exhaustion_tailored = /** @type {(inputs: Credit_Exhaustion_TailoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} CV adattati`)
};

const nl_credit_exhaustion_tailored = /** @type {(inputs: Credit_Exhaustion_TailoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} cv's aangepast`)
};

const pl_credit_exhaustion_tailored = /** @type {(inputs: Credit_Exhaustion_TailoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dostosowano ${i?.count} CV`)
};

const fi_credit_exhaustion_tailored = /** @type {(inputs: Credit_Exhaustion_TailoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mukautettu ${i?.count} ansioluetteloa`)
};

const da_credit_exhaustion_tailored = /** @type {(inputs: Credit_Exhaustion_TailoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tilpasset ${i?.count} CV'er`)
};

const sv_credit_exhaustion_tailored = /** @type {(inputs: Credit_Exhaustion_TailoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anpassat ${i?.count} CV:n`)
};

/**
* | output |
* | --- |
* | "Tailored {count} resumes" |
*
* @param {Credit_Exhaustion_TailoredInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const credit_exhaustion_tailored = /** @type {((inputs: Credit_Exhaustion_TailoredInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Credit_Exhaustion_TailoredInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_credit_exhaustion_tailored(inputs)
	if (locale === "fr") return fr_credit_exhaustion_tailored(inputs)
	if (locale === "es") return es_credit_exhaustion_tailored(inputs)
	if (locale === "it") return it_credit_exhaustion_tailored(inputs)
	if (locale === "nl") return nl_credit_exhaustion_tailored(inputs)
	if (locale === "pl") return pl_credit_exhaustion_tailored(inputs)
	if (locale === "fi") return fi_credit_exhaustion_tailored(inputs)
	if (locale === "da") return da_credit_exhaustion_tailored(inputs)
	if (locale === "sv") return sv_credit_exhaustion_tailored(inputs)
	return en_credit_exhaustion_tailored(inputs)
});